// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"71ee25f926b1aaa7","6924":"15606a1279ac5126","9221":"44c73d2e95e88c20"}[chunkId] + ".js";
};